<div class="content-frame" #content role="tooltip" id="popperDiv">
    <ng-content #main></ng-content>    
    <div id="popper-arrow" *ngIf="!mobileView" ></div>
</div>
